// Load Foundation
jQuery(document).foundation();

// Absolute Center Image Block Title
jQuery('.block-image-title').each(function() {

	var width = jQuery(this).find('span').innerWidth() + 35;
	var height= jQuery(this).find('span').innerHeight() + 15;

	jQuery(this).css('width', width + 'px');
	jQuery(this).css('height', height + 'px');

});

jQuery(function($) {

  // Mobile menu
  $('#mobile-nav-trigger').click(function(e) {
    e.preventDefault();
    $('.primary-navigation').slideToggle();
    $(this).toggleClass('active');
  });

});